__turbopack_context__.v({
  "infoItemWithTag": "_54KvgG_infoItemWithTag",
  "infoItemWithTagItemWrapper": "_54KvgG_infoItemWithTagItemWrapper",
  "infoTag": "_54KvgG_infoTag",
  "infoWrapper": "_54KvgG_infoWrapper",
});
